module.exports = __webpack_public_path__ + "img/no.bce3ef58.svg";